import React from 'react';
import { 
  Bed, Wifi, Bath, Coffee, ParkingCircle, Tv, Wind, Waves, 
  Shirt, KeyRound, Package, UtensilsCrossed, Sparkles, Flame, TreePine, Archive 
} from 'lucide-react';
import { amenities } from '../mock';

export const Amenities = () => {
  // Map icon names to components
  const iconMap = {
    'Bed': Bed,
    'Wind': Wind,
    'Shirt': Shirt,
    'Wifi': Wifi,
    'Tv': Tv,
    'ParkingCircle': ParkingCircle,
    'KeyRound': KeyRound,
    'Hanger': Archive,
    'Coffee': Coffee,
    'UtensilsCrossed': UtensilsCrossed,
    'Bath': Bath,
    'Sparkles': Sparkles,
    'Waves': Waves,
    'Flame': Flame,
    'TreePine': TreePine
  };

  // Group amenities by category
  const amenityGroups = [
    {
      title: "Comfort & Sleep",
      items: amenities.filter(a => ['Bed', 'Wind', 'Shirt'].includes(a.icon))
    },
    {
      title: "Essentials",
      items: amenities.filter(a => ['Wifi', 'Tv', 'ParkingCircle', 'KeyRound', 'Hanger'].includes(a.icon))
    },
    {
      title: "Kitchen & Dining",
      items: amenities.filter(a => ['Coffee', 'UtensilsCrossed'].includes(a.icon))
    },
    {
      title: "Bathroom",
      items: amenities.filter(a => ['Bath', 'Sparkles'].includes(a.icon))
    },
    {
      title: "Outdoor Experience",
      items: amenities.filter(a => ['Waves', 'Flame', 'TreePine'].includes(a.icon))
    }
  ];

  return (
    <section id="amenities" className="py-12 sm:py-16 md:py-20 lg:py-28 bg-[#F5F4F1]">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          {/* Header - Mobile Typography */}
          <div className="text-center mb-10 sm:mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-[#071936] mb-3 sm:mb-4">
              What's Included
            </h2>
            <p className="text-base sm:text-lg text-[#6B7280] max-w-2xl mx-auto px-4">
              Everything you need for a comfortable, simple, and restorative stay.
            </p>
          </div>

          {/* Amenity Groups - Mobile Stack */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-10 md:gap-12">
            {amenityGroups.map((group, groupIndex) => (
              <div key={groupIndex}>
                <h3 className="text-xs sm:text-sm uppercase tracking-wider text-[#6B7280] mb-5 sm:mb-6 font-medium">
                  {group.title}
                </h3>
                <ul className="space-y-3 sm:space-y-4">
                  {group.items.map((item, itemIndex) => {
                    const IconComponent = iconMap[item.icon];
                    if (!IconComponent) return null;
                    
                    return (
                      <li key={itemIndex} className="flex items-start gap-3">
                        <IconComponent className="text-[#2AA7A1] flex-shrink-0 mt-0.5" size={20} strokeWidth={1.5} />
                        <div>
                          <span className="text-[#1F2937] text-sm sm:text-base font-medium block">{item.name}</span>
                          <span className="text-[#6B7280] text-xs sm:text-sm">{item.description}</span>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
